import './UserAvatar.css'

interface UserAvatarProps {
  displayName: string
  discordId?: string | null
  discordAvatar?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/**
 * Renders a Discord avatar with a letter fallback when no profile image exists.
 */
export default function UserAvatar({
  displayName,
  discordId,
  discordAvatar,
  size = 'md',
  className = '',
}: UserAvatarProps) {
  const avatarUrl =
    discordAvatar && discordId
      ? `https://cdn.discordapp.com/avatars/${discordId}/${discordAvatar}.png?size=96`
      : null

  return avatarUrl ? (
    <img
      src={avatarUrl}
      alt={displayName}
      className={`user-avatar user-avatar-${size} ${className}`.trim()}
      loading="lazy"
    />
  ) : (
    <div
      className={`user-avatar user-avatar-${size} user-avatar-fallback ${className}`.trim()}
      aria-label={displayName}
    >
      {displayName.charAt(0).toUpperCase()}
    </div>
  )
}
